import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ReviewOutputFilenamesDialogData } from 'src/app/models/outputs-collections/review-output-filenames/dialog-data';
import { FilenameEntry } from 'src/app/models/outputs-collections/review-output-filenames/filename-entry';

@Component({
  selector: 'app-review-output-filenames-dialog',
  templateUrl: './review-output-filenames-dialog.component.html',
  styleUrls: ['./review-output-filenames-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReviewOutputFilenamesDialogComponent {
  readonly displayedColumns: string[] = ['product', 'formula', 'generated', 'templateCurrent'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ReviewOutputFilenamesDialogData,
    public readonly dialogRef: MatDialogRef<ReviewOutputFilenamesDialogComponent>,
  ) {}

  get entries(): FilenameEntry[] {
    return this.data.response.entries;
  }
}
